export function SectionHead({ align = 'left', title, subtitle, children }) {
  const center = align === 'center';

  return (
    <div className={center ? 'sectionHead center' : 'sectionHead'}>
      {title ? <h2>{title}</h2> : null}
      {subtitle ? <p className="muted">{subtitle}</p> : null}
      {children}
    </div>
  );
}

